// extracted by mini-css-extract-plugin
export default {"button1":"button_button1__HNa-z","button2":"button_button2__l4qLI","button3":"button_button3__Xi2b2","button4":"button_button4__SBgD2"};